import React, { Component } from "react";
import { Layout, Input, Tooltip, Spin } from "antd/lib/index";
import { Link, withRouter } from "react-router-dom";
import { SearchOutlined, SettingOutlined } from "@ant-design/icons";

import Auxiliary from "util/Auxiliary";
import { connect } from "react-redux";
import { toggleCollapsedSideNav } from "../../../appRedux/actions";
import { TAB_SIZE } from "../../../constants/ThemeSetting";
import axios from "axios";
import config, { productName } from "../../../config";
const { Header } = Layout;
const { Search } = Input;

class Topbar extends Component {
  constructor(props) {
    super(props);
    this.searchInputRef = React.createRef();
  }
  state = {
    admin: "",
    loading: false,
  };

  componentWillMount() {
    this.getAdmin();
  }

  getAdmin = () => {
    this.setState({ loading: true });
    axios
      .get(`${config.API_URL}/admin/get/me`, {})
      .then((response) => {
        console.log("_______________________", response);
        this.setState({
          admin: response.data.data,
          loading: false,
        });
      })
      .catch((err) => {
        console.error("Failed to fetch admin:", err);
        this.setState({ loading: false });
      });
  };
  componentDidMount() {
    // Add keyboard shortcut listener for Ctrl+F
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    // Remove keyboard shortcut listener
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown = (e) => {
    // Check for Ctrl+F (or Cmd+F on Mac)
    if ((e.ctrlKey || e.metaKey) && e.key === "f") {
      e.preventDefault(); // Prevent browser's default find
      if (this.searchInputRef.current) {
        this.searchInputRef.current.focus();
      }
    }
  };

  handleSearch = (value) => {
    if (value && value.trim().length >= 2) {
      this.props.history.push(
        `/admin/search/results?q=${encodeURIComponent(value.trim())}`,
      );
    }
  };

  render() {
    console.log("@@@@@@@@@@@@", this.state);
    return (
      <Auxiliary>
        {this.state.loading ? (
          <Spin />
        ) : (
          <Header
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "0 20px",
              height: "64px",
            }}
          >
            {this.props.setting.width < TAB_SIZE ? (
              <div className="gx-linebar gx-mr-3">
                <i
                  className="gx-icon-btn icon icon-menu"
                  onClick={() => {
                    this.props.dispatch(
                      toggleCollapsedSideNav(!this.props.setting.navCollapsed),
                    );
                  }}
                />
              </div>
            ) : null}

            <Link to="/login" className="gx-d-block gx-d-lg-none gx-pointer">
              {productName}
            </Link>

            {/* Admin Name - Left Side */}

            {/* Search Bar - Center */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                height: "100%",
              }}
            >
              {/* LEFT */}
              <div style={{ flex: 1, display: "flex", alignItems: "center" }}>
                <p style={{ margin: 0 }}>
                  {this.props.auth?.isAuthenticated &&
                    this.props.auth.user.name}
                </p>
              </div>

              {/* CENTER (REAL CENTER) */}
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Search
                  style={{ width: "500px", marginTop: "16px" }}
                  ref={this.searchInputRef}
                  placeholder="Search orders, doctors, practices, invoices... (Ctrl+F)"
                  allowClear
                  enterButton={<SearchOutlined />}
                  size="large"
                  onSearch={this.handleSearch}
                />
              </div>

              {/* RIGHT */}
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                {this.state.admin?.permissions?.includes("adminsetting") && (
                  <Tooltip title="Admin Settings">
                    <Link to="/admin/adminsetting">
                      <SettingOutlined style={{ fontSize: "24px" }} />
                    </Link>
                  </Tooltip>
                )}
              </div>
            </div>
            {/* Admin Settings Gear Icon - Right Side */}
          </Header>
        )}
      </Auxiliary>
    );
  }
}
const mapStateToProps = (state) => ({
  setting: state.setting,
  auth: state.authR,
});

export default withRouter(connect(mapStateToProps)(Topbar));
